import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list_select",
  "use": "icon-list_select-usage",
  "viewBox": "0 0 8 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 5\" id=\"icon-list_select\">\r\n  <path id=\"icon-list_select_icon_arrow\" class=\"cls-1\" d=\"M0,0,4,5,8,0Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol